"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.localeCookieToPath = void 0;
const cookies_1 = require("./cookies");
/**
 * Correct path when locale cookie is set
 */
const localeCookieToPath = (req, res, locales) => {
    const { nextUrl } = req;
    let pathCorrected;
    const locale = req.cookies.get(cookies_1.LOCALE_COOKIE);
    if (locale && locales.includes(locale) && nextUrl.locale !== locale) {
        nextUrl.locale = locale;
        pathCorrected = true;
    }
    return pathCorrected;
};
exports.localeCookieToPath = localeCookieToPath;
exports.default = exports.localeCookieToPath;
